// components
import { ReactComponent as OutlineDocsFilled } from "assets/svg/outline-document-filled.svg";
import { ReactComponent as OutlineImage1 } from "assets/svg/outline-image-1.svg";
import { ReactComponent as OutlineSound2 } from "assets/svg/outline-sound-2.svg";
import { ReactComponent as OutlineFolder } from "assets/svg/outline-folder.svg";
import { ReactComponent as OutlineZipFiles } from "assets/svg/outline-zip-files.svg";
// styles
import styles from "./styles.module.scss";
import { useMemo } from "react";

// TODO: seems we dont have video icon
// the object keys are combination of both mimetype genre and type
const ICON_TYPES = Object.freeze({
  folder: OutlineFolder,
  image: OutlineImage1,
  audio: OutlineSound2,
  plain: OutlineDocsFilled,
  zip: OutlineZipFiles,
} as const);

type Props = {
  /**
   * mime type
   * @example "application/pdf"
   */
  mimeType?: string;
  defaultType?: string;
};

const TypeIcon = ({ mimeType = "", defaultType = "plain" }: Props) => {
  const IconElement = useMemo(() => {
    // default to image type
    if (!mimeType) {
      return ICON_TYPES[defaultType];
    }
    /**
     * for the full list of mime type:
     * @see https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
     */

    // use Array.some here for short circuit
    const elementKey =
      Object.keys(ICON_TYPES).find((key) => mimeType.includes(key)) ||
      defaultType;

    return ICON_TYPES[elementKey];
  }, [defaultType, mimeType]);
  return <IconElement className={styles["type-icon"]} />;
};

export default TypeIcon;
